<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('question.example') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <img
        class="ts-object-cove ts-m-auto"
        v-lazy="{
          src: image,
          error: image,
          loading: require('@/assets/Rolling-1s-200px_2.svg')
        }"
        alt=""
      />
    </ts-card-wrapper>
  </ts-card>
</template>
<script>
export default {
  name: 'Example',
  computed: {
    image() {
      return require('@/assets/question-types.png')
    }
  }
}
</script>
